<template>
  <div>
    <startAndend
      :readonly="readonly"
      v-for="(item, index) in arr"
      :key="index"
      v-model="arr[index]"
    >
    </startAndend>
  </div>
</template>

<script>
import startAndend from "./startAndend.vue";
export default {
  components: { startAndend },
  props: ["bbb", "readonly"],
  model: {
    prop: "bbb",
    event: "aaa",
  },
  data() {
    return {
      end: 0,
      show: false,
      arr: [],
    };
  },
  methods: {
    tt() {
      var t = this.bbb;
      this.arr = t;
    },
  },
  mounted() {
    this.tt();
  },
  watch:{
    arr(v){
      this.$emit('aaa',v)
    },
    bbb(v){
      this.tt();
    }
  },
  
};
</script>
<style>
.numberdiv {
  width: 200px;
  border: solid 2px red;
}
</style>


// WEBPACK FOOTER //
// src/components/wuliu/kehu/baojia/moreLine.vue